<div class="branches-wrapper">
  <div class="branches-header">
    <h3>{{ 'HOME_BRANCHES.TITLE' | translate }}</h3>
    <p class="subtitle">{{ 'HOME_BRANCHES.SUBTITLE' | translate }}</p>
  </div>

  <ng-template #branchSelector>
    <div class="branch-selector" *ngIf="selectedCity">
      <div class="city-label">{{ getCityShortLabel(selectedCity) }}</div>
      <div class="branch-buttons">
        <button
          *ngFor="let branch of selectedCity.branches; let i = index"
          class="branch-btn"
          [class.active]="selectedBranchIndex === i"
          (click)="selectBranch(i)"
        >
          <mat-icon class="branch-icon" svgIcon="location_on"></mat-icon>
          <span>{{ branch.branchName || branch.name }}</span>
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #branchMeta>
    <div class="branch-meta">
      <div class="branch-meta-row">
        <mat-icon class="branch-meta-icon" svgIcon="location_on"></mat-icon>
        <span class="branch-meta-text">{{ getFullAddress() }}</span>
      </div>
      <div class="branch-meta-row" *ngIf="scheduleLines.length">
        <mat-icon class="branch-meta-icon" svgIcon="access_time"></mat-icon>
        <span class="branch-meta-text">
          <ng-container *ngFor="let line of scheduleLines; let last = last">
            <span class="branch-meta-label">{{ getScheduleLineLabel(line) }}</span>
            {{ ' ' }}{{ getScheduleHours(line) }}
            <br *ngIf="!last" />
          </ng-container>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #amenitiesDesktop>
    <div class="amenities-block">
      <div class="amenity-row">
        <div class="amenity-badge" *ngIf="hasAmenity('wifi')">
          <mat-icon svgIcon="wifi"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_WIFI' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('private_room')">
          <mat-icon svgIcon="meeting_room"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_PRIVATE_ROOM' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('is_main_road')">
          <mat-icon svgIcon="traffic"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_MAIN_ROAD' | translate }}</span>
        </div>
      </div>
      <div class="amenity-row">
        <div class="amenity-badge" *ngIf="hasAmenity('mall')">
          <mat-icon svgIcon="business"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_MALL' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('parking')">
          <mat-icon svgIcon="local_parking"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_PARKING' | translate }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #amenitiesMobile>
    <div class="amenities-columns-mobile">
      <div class="amenities-column">
        <div class="amenity-badge" *ngIf="hasAmenity('wifi')">
          <mat-icon svgIcon="wifi"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_WIFI' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('parking')">
          <mat-icon svgIcon="local_parking"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_PARKING' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('is_main_road')">
          <mat-icon svgIcon="traffic"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_MAIN_ROAD' | translate }}</span>
        </div>
      </div>
      <div class="amenities-column">
        <div class="amenity-badge" *ngIf="hasAmenity('mall')">
          <mat-icon svgIcon="business"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_MALL' | translate }}</span>
        </div>
        <div class="amenity-badge" *ngIf="hasAmenity('private_room')">
          <mat-icon svgIcon="meeting_room"></mat-icon>
          <span>{{ 'HOME_BRANCHES.AMENITY_PRIVATE_ROOM' | translate }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #contactButtons let-mobile="mobile">
    <div
      class="contact-buttons"
      [class.contact-buttons--mobile]="mobile"
    >
      <a
        mat-fab
        class="contact-btn"
        [href]="'tel:' + getBranchPhone()"
        [matTooltip]="'HOME_BRANCHES.TOOLTIP_CALL' | translate"
      >
        <mat-icon svgIcon="call"></mat-icon>
      </a>
      <a
        mat-fab
        class="contact-btn"
        [href]="getWhatsappUrl()"
        target="_blank"
        [matTooltip]="'HOME_BRANCHES.TOOLTIP_WHATSAPP' | translate"
      >
        <mat-icon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
            />
          </svg>
        </mat-icon>
      </a>
      <a
        mat-fab
        class="contact-btn"
        [href]="getGoogleMapsUrl()"
        target="_blank"
        [matTooltip]="'HOME_BRANCHES.TOOLTIP_GOOGLE_MAPS' | translate"
      >
        <mat-icon svgIcon="navigation"></mat-icon>
      </a>
    </div>
  </ng-template>

  <ng-template #reserveButton let-footer="footer">
    <button
      mat-raised-button
      color="accent"
      class="reserve-btn-branches"
      [class.reserve-btn-branches--header]="!footer"
      [class.reserve-btn-branches--footer]="footer"
      [attr.aria-label]="'HOME_BRANCHES.RESERVE_ARIA_LABEL' | translate"
      (click)="triggerReserveDialog()"
    >
      {{ 'HOME_BRANCHES.RESERVE_BUTTON' | translate }}
      <mat-icon iconPositionEnd svgIcon="payments"></mat-icon>
    </button>
  </ng-template>

  <!-- Mobile -->
  <div class="branches-mobile hide-desktop">
    <div class="branches-mobile__panel">
      <div class="branches-mobile__city-select" *ngIf="cities.length">
        <div class="branches-mobile__city-field-wrap">
          <span class="branches-mobile__city-caption">
            {{ 'HOME_BRANCHES.SELECT_CITY_LABEL' | translate }}
          </span>
          <mat-form-field appearance="outline" class="branches-mobile__city-field">
            <mat-select
              [value]="selectedCityIndex"
              [attr.aria-label]="'HOME_BRANCHES.SELECT_CITY_LABEL' | translate"
              (selectionChange)="onCitySelectChange($event.value)"
            >
              <mat-select-trigger>
                <span class="branches-mobile__city-trigger">
                  <span class="branches-mobile__city-trigger-value">
                    <mat-icon class="branches-mobile__city-icon" svgIcon="location_on"></mat-icon>
                    <span>{{ getCitySelectLabel(cities[selectedCityIndex]) }}</span>
                  </span>
                  <mat-icon class="branches-mobile__city-chevron" svgIcon="keyboard_arrow_down"></mat-icon>
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let city of cities; let i = index" [value]="i">
                {{ getCitySelectLabel(city) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="branches-mobile__selector" *ngIf="selectedCity">
        <p class="branches-mobile__selector-label">
          {{ getCityShortLabel(selectedCity) }}
        </p>
        <div class="branches-mobile__selector-list">
          <button
            *ngFor="let branch of selectedCity.branches; let i = index"
            type="button"
            class="branches-mobile__branch-btn"
            [class.branches-mobile__branch-btn--active]="selectedBranchIndex === i"
            (click)="selectBranch(i)"
          >
            <mat-icon class="branches-mobile__branch-icon" svgIcon="location_on"></mat-icon>
            <span>{{ branch.branchName || branch.name }}</span>
          </button>
        </div>
      </div>

      <div class="branches-mobile__detail" *ngIf="selectedBranch">
        <h2 class="branches-mobile__title">
          <span>{{ getBranchName() }}</span>
          <span>{{ selectedBranch.address.city }}</span>
        </h2>

        <div class="branches-mobile__image">
          <img
            [src]="
              selectedBranch.officeImageUrl ||
              'https://placehold.co/422x409/1a1a1a/FFFFFF?text=' +
                ('HOME_BRANCHES.OFFICE_PLACEHOLDER_TEXT' | translate)
            "
            [alt]="
              'HOME_BRANCHES.IMAGE_ALT' | translate : { name: getBranchName() }
            "
          />
        </div>

        <div class="branches-mobile__carousel-dots" aria-hidden="true">
          <span class="branches-mobile__carousel-dot branches-mobile__carousel-dot--active"></span>
          <span class="branches-mobile__carousel-dot"></span>
          <span class="branches-mobile__carousel-dot"></span>
          <span class="branches-mobile__carousel-dot"></span>
        </div>

        <div class="branches-mobile__info">
          <ng-container *ngTemplateOutlet="branchMeta"></ng-container>
          <ng-container *ngTemplateOutlet="amenitiesMobile"></ng-container>
        </div>

        <div class="branches-mobile__map" id="map-section-mobile">
          <h3 class="branches-mobile__map-title">
            {{ 'HOME_BRANCHES.MAP_TITLE' | translate }}
          </h3>
          <div class="branches-mobile__map-container">
            <div #mapMobile class="map"></div>
          </div>
        </div>

        <ng-container
          *ngTemplateOutlet="contactButtons; context: { mobile: true }"
        ></ng-container>
        <ng-container *ngTemplateOutlet="reserveButton; context: { footer: true }"></ng-container>
      </div>
    </div>
  </div>

  <!-- Desktop -->
  <div class="branches-desktop hide-mobile">
    <div class="city-tabs">
      <button
        *ngFor="let city of cities; let i = index"
        class="city-tab"
        [class.active]="selectedCityIndex === i"
        (click)="selectCity(i)"
      >
        {{ city.name }} ({{ city.count }})
      </button>
    </div>

    <div class="branches-content">
      <div class="images-section">
        <div class="branch-image">
          <img
            [src]="
              selectedBranch?.officeImageUrl ||
              'https://placehold.co/422x409/1a1a1a/FFFFFF?text=' +
                ('HOME_BRANCHES.OFFICE_PLACEHOLDER_TEXT' | translate)
            "
            [alt]="
              'HOME_BRANCHES.IMAGE_ALT' | translate : { name: getBranchName() }
            "
          />
        </div>
        <div id="map-section" class="map-container">
          <div #mapDesktop class="map"></div>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="branchSelector"></ng-container>

      <div class="branch-info branch-info--desktop" *ngIf="selectedBranch">
        <div class="branch-info-header">
          <h2 class="branch-title">
            {{ getBranchName() }} - {{ selectedBranch.address.city }}
          </h2>
          <ng-container *ngTemplateOutlet="reserveButton; context: { footer: false }"></ng-container>
        </div>

        <ng-container *ngTemplateOutlet="branchMeta"></ng-container>

        <div class="info-container">
          <ng-container *ngTemplateOutlet="amenitiesDesktop"></ng-container>
          <ng-container *ngTemplateOutlet="contactButtons"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
